export default __webpack_public_path__ + "static/media/rabbit.de0226bf.webp";